import * as Inventory from '../inventory';
import { PetSpeciesID } from '../pet';
import { getEquippedPetSpecies } from '../pet/pet.getters';
import { State } from '../State';

/**
 * Check whether the player is a guest.
 * @param state - user state
 * @returns true if the player is a guest, false otherwise
 */
export function isGuestUser(state: { id: string }): boolean {
  return state.id?.startsWith('web_');
}

export type StateSummary = {
  species: PetSpeciesID | undefined;
  matchLevel: number;
  gems: number;
  points: number;
  origin: 'line' | 'guest';
  lastPlayedAt: number;
  paidGems?: number;
};

/**
 * Get state summary for a given state.
 * @param state - user state
 * @returns state summary object containing species, match level, gems, and points
 */
export function getStateSummary(
  state: State,
  origin: StateSummary['origin'],
  lastPlayedAt: number,
): StateSummary {
  return {
    species: getEquippedPetSpecies(state),
    matchLevel: state.match2.level,
    gems: Inventory.getters.getGems(state),
    points: Inventory.getters.getPoints(state),
    origin,
    lastPlayedAt,
    paidGems: Inventory.getters.getPaidGems(state),
  };
}
